import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AutenticadoGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {

  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.validate();
  }

  private async validate() {
    try {
      const autenticado = this.authService.existeUsuarioLogado();
      if (autenticado) {
        return true;
      } else {
        await this.router.navigate(['/']);
        return false;
      }
    } catch (error) {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/guards/autenticado.guard.ts